module.exports = __webpack_public_path__ + "img/3.d48ef8c9.png";